// extracted by mini-css-extract-plugin
export default {"link":"ForgotPasswordLink_link__AarhA"};